module.exports = __webpack_public_path__ + "static/media/10C.ab649f97.jpg";